import * as React from 'react';
import { isFunction } from 'lodash';

// types
import { IGenericFunction } from 'types/generics';
import { ILoadingManagerComponentProps } from './loading-manager.types';

// components
import Spinner from 'components/spinner/spinner.component';
import ContentView from 'components/content/subcomponents/content-view.component';

// constants
import { LOADING_STATE } from 'modules/loading-manager/loading-manager.constants';
import { WEBSITE_MODE } from '@sitegen/common/constants';

export default class LoadingManager extends React.Component<ILoadingManagerComponentProps> {
    public componentDidMount() {
        let combinedActions: IGenericFunction<void>[] = this.props.actions.modeAgnostic;
        if (this.props.mode === WEBSITE_MODE.STANDALONE && this.props.actions.standalone) {
            combinedActions = [
                ...combinedActions,
                ...this.props.actions.standalone
            ];
        }
        combinedActions.forEach(action => isFunction(action) && action());
    }

    public render(): JSX.Element | null {
        return this.props.loading !== LOADING_STATE.LOADED
            ? <ContentView shouldInheritStyles={this.props.shouldInheritStyles}>
                <Spinner />
            </ContentView>
            : <>{this.props.children}</>;
    }
}
